import APIService from './apiService';
import { Item, ItemSpec } from '../types';

export default class ItemService {
  private apiService: APIService;

  constructor() {
    this.apiService = new APIService();
  }

  public fetchItemsForUser(userID: string): Promise<Item[]> {
    const endpoint = `/items?userID=${userID}`;

    return this.apiService.getRequest(endpoint)
      .then((response) => {
        return response.json();
      })
      .then((responseObject) => {
        return responseObject.items;
      });
  }

  public createItem(itemSpec: ItemSpec): Promise<Item> {
    return this.apiService.postRequest('/items', itemSpec)
      .then((response) => {
        return response.json();
      })
      .then((responseObject) => {
        return responseObject.item;
      });
  }

  public updateItem(item: Item): Promise<void> {
    const endpoint = `/items/${item._id}`;

    return this.apiService.putRequest(endpoint, item)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to update item with ID ${item._id}`);
        }
      });
  }

  public unpurchaseItem(itemID: string): Promise<void> {
    const endpoint = `/items/${itemID}/unpurchase`;

    return this.apiService.postRequest(endpoint)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to update item with ID ${itemID}`);
        }
      });
  }

  public deleteItemWithID(id: string): Promise<void> {
    const endpoint = `/items/${id}`;

    return this.apiService.deleteRequest(endpoint)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to delete item with ID ${id}`);
        }
      });
  }
}
